var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfRating',{staticClass:"flex gap-2 rating-star-color",class:_vm.size === 'lg' ? 'lg' : '',attrs:{"max":_vm.max,"score":Number(_vm.score),"icon":_vm.starSvgPath}})}
var staticRenderFns = []

export { render, staticRenderFns }